import React from 'react';
import { connect } from 'react-redux';
// import FooterVariablePositives from '../FooterVariablePositives/FooterVariablePositives';

const DisplayGraph = ({ detail, nameProduct }) => {
  const listCli = detail.listCliSubDetail && detail.listCliSubDetail.length > 0 ? detail.listCliSubDetail[0] : detail;
  const formattedText = listCli?.title?.split('שנה')[0];

  return (
    <div className='container-addDevice'>
      {/* <div className='wrapper-title'>
        {listCli.title && <div className='title'>{formattedText}</div>}
        {listCli?.amountData?.amount &&
          <div>₪{listCli?.amountData?.amount}.{listCli?.amountData?.amountAgorot}
            {listCli?.amountData?.isAmountMinus ? '-' : ''}</div>
        }
      </div> */}
      <div className='wrapper-graph'>
        {listCli.graphTitle && <div>{listCli.graphTitle}</div>}
        <div className='graph' >
          {listCli.graphPercent && <div className='inside-graph' style={{ width: listCli.graphPercent + '%' }}></div>}
        </div>
      </div>
      {/* {listCli.graphPercent &&<FooterVariablePositives detail={detail} nameProduct={nameProduct}/> } */}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {

  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(DisplayGraph);
